import React, {Component} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {Redirect, Route, Switch, withRouter} from 'react-router'
import PropTypes from 'prop-types';

import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions'

import './App.css';
import 'semantic-ui-css/semantic.min.css';
import UpdateAvailableModal from "./common/UpdateAvailableModal";
import Status from "./routes/Status";

import * as config from './config';
import * as firebase from "firebase";

class App extends Component {

	constructor(props) {
		super(props);

		this.state = {
			updateAvailable: false,
		};

		this.firebase = firebase.initializeApp(config.FIREBASE_CONFIG);
	}

	componentDidMount() {
		if (process.env.NODE_ENV === 'production') {
			if (!!this.props.update) {
				this.props.update.then(() => this.setState({updateAvailable: true})).catch();
			} else {
				console.warn('Received null promise for app update');
			}
		}
	}

	render() {
		return (
			<Router>
				<Switch>
					<Route path='/'>
						<Router>
							<ScrollRestorer>
								<Switch>
									<Route path='/'>
										<Status/>
									</Route>
									<Route path='*'>
										<Redirect to='/'/>
									</Route>
								</Switch>
								{this.state.updateAvailable && <UpdateAvailableModal/>}
							</ScrollRestorer>
						</Router>
					</Route>
				</Switch>
			</Router>

		);
	}
}

App.propTypes = {
	update: PropTypes.instanceOf(Promise)
};

class ScrollToTop extends Component {
	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0)
		}
	}

	render() {
		return this.props.children
	}
}

const ScrollRestorer = withRouter(ScrollToTop);

export default App;



// WEBPACK FOOTER //
// ./src/App.js